export const callbackRequestDefault = (eventBus) => ({
  success(config) {
    eventBus.publish('start', {
      config,
    })

    return config
  },
})
